import React, { useState, useEffect, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { Route, Routes, useNavigate } from 'react-router-dom';


import toast from 'react-hot-toast';
import { DatePicker, Space } from 'antd';
import moment from 'moment';
import { DataContext } from '../../../init/getData';

import Chart from "react-apexcharts";



const YearlySales = (props) => {

  const { userData, settingData, devData, api, companyId, yearId, selectedYear } = useContext(DataContext);

  const [filter, setFilter] = useState({ year: moment().year() });
  const [loadingCounter, setLoadingCounter] = useState(0);
  const [yearlySales, setYearlySales] = useState(0);



  useEffect(() => {
    getData();
  }, [filter]);


  const getData = async () => {

    let data = {
      selectedYear,
      companyId,
      yearId,
      settingData,
      branchId: null,
    };

    await api.get(`/dashBoard/getSalesYearly`, { params: data }).then(response => {
      if (!response.data.status) {
        toast.error('Failed to get Data')
      } else {
        setYearlySales(response.data?.yearlySales)
      }
    }
    )

  }



  const [chartOptions, setChartOptions] = useState({
    chart: {
      id: "basic-line-chart",
    },
    xaxis: {
      categories: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    },
  });

  // Chart data
  const chartSeries = [
    {
      name: "Sales",
      data: [
        yearlySales?.January?.secondarySalesRevenue,
        yearlySales?.February?.secondarySalesRevenue,
        yearlySales?.March?.secondarySalesRevenue,
        yearlySales?.April?.secondarySalesRevenue,
        yearlySales?.May?.secondarySalesRevenue,
        yearlySales?.June?.secondarySalesRevenue,
        yearlySales?.July?.secondarySalesRevenue,
        yearlySales?.August?.secondarySalesRevenue,
        yearlySales?.September?.secondarySalesRevenue,
        yearlySales?.October?.secondarySalesRevenue,
        yearlySales?.November?.secondarySalesRevenue,
        yearlySales?.December?.secondarySalesRevenue,
      ]
    },
  ]


  return (

    <div>
      {yearlySales &&
        <div>
          <h2>Sales Revenue</h2>
          <Chart
            options={chartOptions}
            series={chartSeries}
            type="line" // Chart type: 'line', 'bar', 'pie', etc.
            height="350"
          />
        </div>
      }
    </div>
  
  );
}


export default YearlySales;